module.exports = __webpack_public_path__ + "img/zz1.b3346de3.png";